import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { SimpleNotification } from '@core/models/notifications/simple-notification';

export interface NotificationDetailDialogData {
  notification: SimpleNotification;
}

@Component({
  selector: 'app-notification-detail-dialog',
  standalone: true,
  imports: [CommonModule, MatDialogModule, MatButtonModule],
  templateUrl: './notification-detail-dialog.component.html',
  styleUrls: ['./notification-detail-dialog.component.scss'],
})
export class NotificationDetailDialogComponent {

  constructor(
    private dialogRef: MatDialogRef<NotificationDetailDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: NotificationDetailDialogData
  ) {}

  close(): void {
    this.dialogRef.close();
  }
}
